var React = require('react');

function MenuDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"arrow-right","fill":"#D52430"},React.createElement("path",{"d":"M2.51364401,7.51364401 C5.82878533,4.17926812 7.48635599,2.51208018 7.48635599,2.51208018 C7.48635599,2.51208018 5.82878533,0.845934791 2.51364401,-2.48635599 L2.51364401,7.51364401 Z","id":"Path","transform":"translate(5.000000, 2.513644) rotate(90.000000) translate(-5.000000, -2.513644) "})))]);
}

MenuDown.defaultProps = {"width":"10px","height":"5px","viewBox":"0 0 10 5","version":"1.1"};

module.exports = MenuDown;

MenuDown.default = MenuDown;
